'use strict';

var _ = require('lodash');

function AnalyticsService ($window, IdentityService, sbAnalytics, $location) {
  var minutes = 0;
  var user;
  var group;
  var sessionId;
  var traits = {};
  var locationSearch = $location.search();
  var context = {
    campaign: _.omit({
      name: locationSearch.utm_campaign,
      source: locationSearch.utm_source,
      medium: locationSearch.utm_medium,
      term: locationSearch.utm_term,
      content: locationSearch.utm_content
    }, _.isUndefined),
    landingPage: locationSearch.landing_page,
    query: _.omit(locationSearch, [
      'utm_campaign',
      'utm_source',
      'utm_medium',
      'utm_term',
      'utm_content',
      'token'
    ])
  };

  /**
   * Method used to send a tracking event to Segment
   *
   * @param  {string} eventName the event name
   * @param  {object} dacs data to send with the event
   */
  this.track = function(category, eventName, eventData, integrations) {
    // Track time on site w/ every event
    eventData.minutes = minutes;

    /* start adwords conversion code */
    if (eventName === 'Sign Up Success' && window.google_trackConversion) {
      if (IdentityService.getEnv() === 'production') {
        console.info('Sending adwords conversion code for signup');
        window.google_trackConversion({
          google_conversion_id: 963993235,
          google_conversion_label: "fTzHCNDl52oQk73VywM",
          google_remarketing_only: false
        });
      } else {
        console.warn('Adwords conversion code for signup not sent', {
          env: IdentityService.getEnv()
        });
      }
    }
    /* end adwords conversion code */

    if (window.fbq) {
      fbq('trackCustom', eventName, eventData);
    }

    return sbAnalytics.track(category, eventName, eventData, integrations);
  };


  /**
   * Method that is called when the user data becomes updated (login, logout);
   */
  this.reIdentify = function() {
    _init();
    sbAnalytics.identify(user.id, traits, context, {
      'Intercom': false
    });
  };
  /**
   * Identifies the current user to Segment and begins tracking the user time on site.
   * This should be triggered as soon as the app starts.
   */
  this.identify = function () {
    _init();
    sbAnalytics.identify(user.id, traits, context, {
      'Intercom': false
    });
    this.track('[CORE] Authentication', 'Success', {
      email: IdentityService.getUser().email
    });
    $window.setInterval(function () {
      minutes++;
      if ((minutes <= 60 && minutes % 5 === 0) || (minutes > 60 && minutes % 30 === 0)) {
        sbAnalytics.track('[CORE] General', 'Time on Site', {
          minutes: minutes,
          sessionId: sessionId
        }, {
          'Intercom': false,
          'Mixpanel': false
        });
      }
    }, 60 * 1000);
  };

  this.page = function (page) {
    return sbAnalytics.page(page);
  };

  function getName (user) {
    var name;

    if (user.firstName && user.lastName) {
      name = user.firstName + ' ' + user.lastName;
    } else if (user.firstName) {
      name = user.firstName;
    } else if (user.lastName) {
      name = user.lastName;
    } else {
      name = 'anonymous';
    }

    return name;
  }

  function determineBrowser () {
    // adapted from: http://stackoverflow.com/a/9851769

    if (!!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) {
      // Opera 8.0+ (UA detection to detect Blink/v8-powered Opera)
      return 'Opera';
    } else if (typeof InstallTrigger !== 'undefined') {
      // Firefox 1.0+
      return 'Firefox';
    } else if (Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0) {
      // At least Safari 3+: "[object HTMLElementConstructor]"
      return 'Safari';
    } else if (!!window.chrome) {
      // Chrome 1+
      return 'Chrome';
    } else if (/*@cc_on!@*/false || !!document.documentMode) {
      // At least IE6
      return 'IE';
    } else {
      return 'Unknown';
    }
  }

  function _init () {
    user = IdentityService.getUser();
    group = IdentityService.getCurrentGroup() || null;
    sessionId = user.id + ':' + Date.now();
    locationSearch = $location.search();
    traits = {
      email: user.email,
      group: group,
      name: getName(user),
      browser: determineBrowser()
    };
    context = {
      sessionId: sessionId,
      adminSession: user.adminSession, // deal with this on mute in the booster
      user_agent: navigator.userAgent,
      campaign: _.omit({
        name: locationSearch.utm_campaign,
        source: locationSearch.utm_source,
        medium: locationSearch.utm_medium,
        term: locationSearch.utm_term,
        content: locationSearch.utm_content
      }, _.isUndefined),
      landingPage: locationSearch.landing_page,
      query: _.omit(locationSearch, [
        'utm_campaign',
        'utm_source',
        'utm_medium',
        'utm_term',
        'utm_content'
      ])
    };
  }
}

module.exports = AnalyticsService;



// WEBPACK FOOTER //
// ./src/common/analytics/AnalyticsService.js